import momentTz from "moment-timezone";

/* eslint-disable no-redeclare */
export function beautifyKey(key) {
	//Replace underscores with spaces
	var replace = key.split("_").join(" ").split("-").join(" ");
	//Capitalize first letter of every word in the string
	var words = replace.split(" ");
	var newKey = [];
	words.forEach((element) => {
		newKey.push(element[0].toUpperCase() + element.slice(1, element.length));
	});
	return newKey.join(" ");
}

export function search(items, searchParam, query) {
	//Filter out items which do not satisfy the condition
	return items.filter((item) => {
		//check values of some predefined properties for search result
		return searchParam.some((newItem) => {
			return (
				//Check the value of the property with the query
				item[newItem].toString().toLowerCase().indexOf(query.toLowerCase()) > -1
			);
		});
	});
}

export function setProperty(obj, value, path) {
	var schema = obj; // a moving reference to internal objects within obj
	var pList = path.split(".");
	var len = pList.length;
	for (var i = 0; i < len - 1; i++) {
		var elem = pList[i];
		if (!schema[elem]) schema[elem] = {};
		schema = schema[elem];
	}

	schema[pList[len - 1]] = value;

	return obj;
}

//Recursive function to get nested properties of an object dynamically
export function getNestedValue(obj, path) {
	if (!obj) return null;
	//return obj if there are no more nested values
	if (!path) return obj;
	const properties = path.split(".");
	//get the first property of the path using shift and pass the remaining path as argument
	return getNestedValue(obj[properties.shift()], properties.join("."));
}

//Function to create empty nested object properties to fill
export function createNestedObject(base, names, array) {
	//Travel the heirarchy
	for (var i = 0; i < names.length; i++) {
		if (array) {
			//Create an empty object if the nested object doesn't exist
			base = base[names[i]] = base[names[i]] || [];
		} else {
			base = base[names[i]] = base[names[i]] || {};
		}
	}
}

//Generate a random ID
export const randomId = () => {
	return Math.floor((1 + Math.random()) * 0x10000)
		.toString(16)
		.substring(1);
};

//Function to convert sconds into human readable format
export function convertTime(seconds) {
	var seconds = seconds * 60;
	var hours = Math.floor(seconds / 3600);
	var minutes = Math.floor((seconds - hours * 3600) / 60);
	var seconds = seconds - hours * 3600 - minutes * 60;
	var days = Math.floor(hours / 24);
	var str = "";

	if (!!days) {
		var remainder = hours % 24;
		if (!!remainder) str += ` ${days}d ${remainder}h`;
		else str += ` ${days}d`;
	} else if (!!hours) str += ` ${hours}h`;

	if (!!minutes) str += ` ${minutes}m`;

	if (!!seconds) str += ` ${seconds}s`;

	return str;
}

export function isEmpty(obj) {
	if (!obj) return true;
	for (const key in obj) {
		return false;
	}
	return true;
}

export function isObject(obj) {
	return obj !== null && typeof obj === "object";
}

export function diff(obj1, obj2) {
	// Make sure an object to compare is provided
	if (!obj2 || Object.prototype.toString.call(obj2) !== "[object Object]") {
		return obj1;
	}

	var diffs = {};
	var key;

	var arraysMatch = function (arr1, arr2) {
		// Check if the arrays are the same length
		if (arr1.length !== arr2.length) return false;

		// Check if all items exist and are in the same order
		for (var i = 0; i < arr1.length; i++) {
			if (arr1[i] !== arr2[i]) return false;
		}

		// Otherwise, return true
		return true;
	};

	var compare = function (item1, item2, key) {
		// Get the object type
		var type1 = Object.prototype.toString.call(item1);
		var type2 = Object.prototype.toString.call(item2);

		// If type2 is undefined it has been removed
		if (type2 === "[object Undefined]") {
			diffs[key] = null;
			return;
		}
		// If items are different types
		if (type1 !== type2) {
			diffs[key] = item2;
			return;
		}
		// If an object, compare recursively
		if (type1 === "[object Object]") {
			var objDiff = diff(item1, item2);
			if (Object.keys(objDiff).length > 0) {
				diffs[key] = objDiff;
			}
			return;
		}
		// If an array, compare
		if (type1 === "[object Array]") {
			if (!arraysMatch(item1, item2)) {
				diffs[key] = item2;
			}
			return;
		}

		// Else if it's a function, convert to a string and compare
		// Otherwise, just compare
		if (type1 === "[object Function]") {
			if (item1.toString() !== item2.toString()) {
				diffs[key] = item2;
			}
		} else {
			if (item1 !== item2) {
				diffs[key] = item2;
			}
		}
	};

	//Compare Objects
	// Loop through the first object
	for (key in obj1) {
		if (obj1.hasOwnProperty(key)) {
			compare(obj1[key], obj2[key], key);
		}
	}
	// Loop through the second object and find missing items
	for (key in obj2) {
		if (obj2.hasOwnProperty(key)) {
			if (!obj1[key] && obj1[key] !== obj2[key]) {
				diffs[key] = obj2[key];
			}
		}
	}
	// Return the object of differences
	return diffs;
}

export function flattenObject(obj, parentKey) {
	const flattened = {};

	Object.keys(obj).forEach((key) => {
		const value = obj[key];
		//If value is of type object recursion
		if (typeof value === "object" && value !== null && !Array.isArray(value)) {
			Object.assign(flattened, flattenObject(value, beautifyKey(key)));
		}
		//Else add valu to flattened object with key as (ParentKey)(ChildKey)
		else {
			if (parentKey) {
				flattened[`${parentKey}${beautifyKey(key)}`] = value;
			} else flattened[key] = value;
		}
	});

	return flattened;
}

export function CamelCaseToText(str) {
	// insert a space before all caps    uppercase the first character
	return str.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
		return str.toUpperCase();
	});
}

export function forceDownloadCSV(data, fileName) {
	var csvFile = new Blob([data], { type: "text/csv" });
	var href = URL.createObjectURL(csvFile);
	var dummyElement = document.createElement("a");
	Object.assign(dummyElement, {
		href,
		download: fileName || "dashboardData.csv",
	}).click();

	dummyElement.remove();
}

let timerId;

export function debounce(func, delay = 1000) {
	clearTimeout(timerId);
	timerId = setTimeout(func, delay);
}

export function deepCopy(obj) {
	if (!obj) return;
	return JSON.parse(JSON.stringify(obj));
}

export function createISOString(dateString, timeString, desiredTimezone) {
	const date = new Date(dateString);
	const year = date.getFullYear();
	const month = date.getMonth() + 1; // moment expects 1-12, not 0-11
	const day = date.getDate();

	const [hours, minutes] = timeString.split(":");

	const momentDate = momentTz.tz(
		`${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")} ${hours}:${minutes}`,
		"YYYY-MM-DD HH:mm",
		desiredTimezone
	);

	return momentDate.toISOString();
}